const DEFAULT_OPTS = {
  onIdle: () => {},
  delay: 1000 * 60 * 5
};
class IdleGuard {
  #timer;
  /**
   * @type {IdleGuard}
   */
  static instance = null;
  constructor(opts) {
    const options = {
      ...DEFAULT_OPTS,
      ...opts
    };
    this.options = options;
    this.addEventListeners();
    this.resetTimer();
  }
  setOpts(opts) {
    if (!opts) {
      return;
    }
    const options = {
      ...DEFAULT_OPTS,
      ...this.options,
      ...opts
    };
    this.options = options;
  }
  onIdle = () => {
    this.options.onIdle();
    this.removeEventListeners();
  };
  resetTimer = () => {
    clearTimeout(this.#timer);
    this.#timer = setTimeout(this.onIdle, this.options.delay);
  };
  addEventListeners() {
    window.addEventListener('load', this.resetTimer, true);
    window.addEventListener('mousemove', this.resetTimer, true);
    window.addEventListener('mousedown', this.resetTimer, true);
    window.addEventListener('touchstart', this.resetTimer, true);
    window.addEventListener('touchmove', this.resetTimer, true);
    window.addEventListener('click', this.resetTimer, true);
    window.addEventListener('keydown', this.resetTimer, true);
    window.addEventListener('scroll', this.resetTimer, true);
    window.addEventListener('wheel', this.resetTimer, true);
  }
  removeEventListeners() {
    window.removeEventListener('load', this.resetTimer, true);
    window.removeEventListener('mousemove', this.resetTimer, true);
    window.removeEventListener('mousedown', this.resetTimer, true);
    window.removeEventListener('touchstart', this.resetTimer, true);
    window.removeEventListener('touchmove', this.resetTimer, true);
    window.removeEventListener('click', this.resetTimer, true);
    window.removeEventListener('keydown', this.resetTimer, true);
    window.removeEventListener('scroll', this.resetTimer, true);
    window.removeEventListener('wheel', this.resetTimer, true);
  }
  teardown() {
    this.removeEventListeners();
    IdleGuard.instance = null;
  }
}
export default {
  start(opts) {
    if (!IdleGuard.instance) {
      IdleGuard.instance = new IdleGuard(opts);
    } else {
      IdleGuard.instance.setOpts(opts);
    }
    return IdleGuard.instance;
  },
  stop() {
    IdleGuard.instance?.teardown();
  }
};